import { Reveal, Overline } from "@/components/Reveal";
import { useLang, tr } from "@/i18n";

const paragraphs = [
    "Dharm Sarovar Private Limited was founded in Bodh Gaya with one purpose — to help families perform the final duties towards their ancestors with complete authenticity, dignity and peace of mind.",
    "Gaya is the holiest kshetra for Pitru karya — the land of Lord Vishnu's footprint at Vishnupad Temple, the sacred Falgu river, and the immortal Akshayavat. We work only with hereditary Gayawal Pandas who have performed these rituals for generations, exactly as prescribed in the scriptures.",
    "From a single-day Pinddaan to the complete 17-day Sapindi Karan, we keep every price transparent — 40% advance, 60% one day before arrival — and assist your family with stay, food and travel so you can focus on the ritual, not the logistics.",
];

export const About = () => {
    const { lang } = useLang();
    const t = (s) => tr(lang, s);
    return (
        <section id="about" data-testid="about-section" className="py-20 lg:py-28 bg-[#FAF6F0] relative grain-overlay">
            <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
                <div className="lg:col-span-7">
                    <Reveal>
                        <Overline>{t("Chapter 05 — Our Story")}</Overline>
                        <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl text-[#241D19] tracking-tight">
                            {t("About Dharm Sarovar")}
                        </h2>
                    </Reveal>
                    <div className="mt-6 space-y-5">
                        {paragraphs.map((p, i) => (
                            <Reveal key={i} delay={0.1 + i * 0.1}>
                                <p className="text-[#6E6259] leading-relaxed">{t(p)}</p>
                            </Reveal>
                        ))}
                    </div>
                </div>
                <Reveal delay={0.2} className="lg:col-span-5">
                    <div className="relative">
                        <img
                            src="/img/charan.jpg"
                            alt="Lord Vishnu's footprint at Vishnupad Temple, Gaya"
                            className="rounded-2xl w-full h-[420px] object-cover border border-[#E6DBCF] shadow-[0_16px_48px_rgba(36,29,25,0.12)]"
                        />
                        <div className="absolute -bottom-5 left-6 bg-[#241D19] text-amber-200 rounded-xl px-5 py-3 shadow-xl">
                            <p className="font-serif-alt italic text-sm">Vishnupad Temple, Gaya</p>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};
